import React from 'react';
import { Card } from '@/components/ui';

const DefaultReportsView: React.FC = () => (
  // flex-1 + min-h-0 fills whatever height the reporting content pane actually has, instead of a
  // 60vh guess - on a phone (where the mobile report picker already takes real estate above this)
  // a vh-based minHeight could push this below the fold, needing an extra scroll to see it.
  <div className="tw-flex tw-flex-1 tw-min-h-0 tw-justify-center tw-items-center">
    <Card>
      <Card.Body>
        <div className="tw-text-center tw-py-5">
          <img 
            src={encodeURI(`${process.env.PUBLIC_URL || ''}/WRAP logo no border.png`)} 
            alt="WRAP Logo" 
            style={{ maxWidth: '200px', maxHeight: '100px', marginBottom: '20px' }}
          />
          {/* Below md the sidebar is replaced by a select at the top of the page, so "the left
              menu" is not a place the reader can look. Name the control per breakpoint. */}
          <h5 className="tw-mt-3 tw-text-content-muted md:tw-hidden">
            Choose a report from the menu above
          </h5>
          <h5 className="tw-mt-3 tw-hidden tw-text-content-muted md:tw-block">
            Select a report from the left menu
          </h5>
        </div>
      </Card.Body>
    </Card>
  </div>
);

export default DefaultReportsView;